var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"el",staticClass:"omapi-link-arrow-before omapi-wizard-back",attrs:{"href":"#","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$bus.$emit('onboardingPrevPage')}}},[_vm._v(" Go Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }